(function () {
    angular.module('tradersyard').component('tySelectBox', {
        // language=HTML
        template: `
            <div class="selection-block">
                <div class="items-selection">
                    <button class="select-text-btn show-select"
                        ng-click="$ctrl.selectItem($ctrl.default)"
                        ng-bind="$ctrl.name"
                    ></button>
                    <button
                        ng-if="$ctrl.canSelect"
                        ng-class="{active: $ctrl.dropdown}"
                        ng-click="$ctrl.dropdown = true"
                    ></button>
                </div>

                <div class="dropdown" ng-show="$ctrl.dropdown"
                     on-click-out="$ctrl.dropdown = false">
                    <ul>
                        <li ng-repeat="(key, item) in $ctrl.values" >
                            <a ng-click="$ctrl.dropdown=false; $ctrl.selectItem(item);">
                                {{item}} {{$ctrl.valueSuffix}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        `,
        bindings: {
            listValues: '<',
            defaultValue: '<',
            buttonName: '<',
            timePeriod: '<',
            day: '<',
            speakerHall: '<',
        },
        transclude: true,
        controller: SelectBoxCtrl,
    });

    SelectBoxCtrl.$inject = ['$scope'];

    function SelectBoxCtrl($scope) {
        const ctrl = this;

        ctrl.canSelect = false;
        ctrl.dropdown = false;

        ctrl.name = 'Add';
        ctrl.valueSuffix = 'Min';
        ctrl.values = [''];
        ctrl.default = ctrl.values[0];

        ctrl.selectItem = function (item) {
            $scope.$parent.onChangeSelectBox(item, ctrl.timePeriod, ctrl.speakerHall, ctrl.day);
        };

        ctrl.$onInit = function () {
            if (typeof ctrl.buttonName !== 'undefined') {
                ctrl.name = ctrl.buttonName;
            }

            if (typeof ctrl.listValues === 'undefined') {
                ctrl.values = [30, 60, 90, 120, 150, 180, 210];

                ctrl.default = ctrl.values[0];
                ctrl.canSelect = true;
            }
        };
    }
})();
